import componentForTooltip from './componentForTooltip.vue'
export default componentForTooltip
